import React from "react";
import styled from "styled-components";
import { FiClock } from "react-icons/fi";
import { Card, Toggle, Slider } from "../styles/shared";

const EnableToggleCard = ({ icon, title, desc, enabled, onChange, disabled }) => (
    <Card>
        <EnableRow>
            <EnableLeft>
                <EnableIconBox>
                    {icon ?? <FiClock size={20} color="#6b7280" />}
                </EnableIconBox>
                <EnableText>
                    <EnableTitle>{title}</EnableTitle>
                    <EnableDesc>{desc}</EnableDesc>
                </EnableText>
            </EnableLeft>
            <Toggle>
                <input
                    type="checkbox"
                    checked={!!enabled}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                />
                <Slider />
            </Toggle>
        </EnableRow>
    </Card>
);

export default EnableToggleCard;

const EnableRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
`;

const EnableLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const EnableIconBox = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

const EnableText = styled.div`
    display: flex;
    flex-direction: column;
`;

const EnableTitle = styled.p`
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    text-align: left;
`;

const EnableDesc = styled.p`
    font-size: 12px;
    color: #6b7280;
    margin: 4px 0 0 0;
    text-align: left;
`;
